import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { pcInsurancePolicies as enumeratedPCInsurancePolicies } from 'Consts/EnumeratedValues';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import Currency from 'Components/Format/Currency';

const PCInsurance = ({
  PCInsurancePolicies,
  editLink,
}) => (
  <Fragment>
    {PCInsurancePolicies?.length > 0 && (
    <Fragment>
      <tr>
        <td colSpan="10">
          <h3>
              Property &amp; Casualty
            {editLink && (<EditButtonLink
              title="Edit Property Insurance"
              to={editLink}
            />)}
          </h3>
        </td>
      </tr>
      <tr className="pc-policies">
        <td colSpan="10" className="pc">
          <div className="item">
            <div className="icon">&nbsp;</div>
            <div className="labels">
                Coverage
              <br />
                Company
              <br />
                Property
              <br />
                Liability
              <br />
                Deductible
            </div>
          </div>
          {PCInsurancePolicies.map(policy => (
            <div className="item" key={`${policy.attributes.id}policy`}>
              <div className="icon">
                <div className={`icon-${policy.attributes.type}`} />
              </div>
              <div>
                {enumeratedPCInsurancePolicies(
                  'type',
                  policy.attributes.type,
                )}
                <br />
                {policy.attributes.company}
                <br />
                <Currency
                  amount={
                      policy.attributes.propertyLimit !== null
                        ? policy.attributes.propertyLimit
                        : 0
                    }
                />
                <br />
                <Currency
                  amount={
                      policy.attributes.liabilityLimit !== null
                        ? policy.attributes.liabilityLimit
                        : 0
                    }
                />
                <br />
                <Currency
                  amount={
                      policy.attributes.deductibles !== null
                        ? policy.attributes.deductibles
                        : 0
                    }
                />
              </div>
            </div>
          ))}
        </td>
      </tr>
    </Fragment>
    )}
  </Fragment>
);

PCInsurance.propTypes = {
  PCInsurancePolicies: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
PCInsurance.defaultProps = {
  editLink: '',
};

export default PCInsurance;
